import React from "react";
import PropTypes from 'prop-types';
import {addImageToLoading, removeImageFromLoading} from "../app/systemSlice";
import {useDispatch} from "react-redux";

const Image = (props) => {
    const dispatch = useDispatch();

    const onLoad = () => dispatch(removeImageFromLoading(props.src));

    const onClick = props.onClick ? props.onClick : null;

    return <img
        className={ props.className? props.className : "game-image" }
        style={props.style}
        src={props.src}
        alt=""
        onClick={onClick}
        onLoad={()=>onLoad()}
    />;
};

Image.propTypes = {
    src: PropTypes.string.isRequired,
    style: PropTypes.object,
    onClick: PropTypes.func,
    className: PropTypes.string
};

export default Image;